import { useEffect, useState } from "react";
import styled from "styled-components";

const ClockMain = styled.div`
position: relative;
display: inline-block;
color: ${props => props.color ? props.color: "black" };
`

const HourNumber = styled.b`
    position: absolute;
    top: 0px;
    left: 50%;
    display: block;
    width: 20px;
    height: 50%;
    margin-left: -10px;
    padding-top: 4%;
    font-weight: 400;
    transform-origin: bottom;
    user-select: none;
    box-sizing: border-box;
    &> span {
        display: block;
        &> i {
            display: block;
            font-style: normal;
        }
    }
    &.hour1 {
            transform: rotateZ(30deg);
        }
    &.hour1 > span {
        transform: rotateZ(-30deg);
    }
    &.hour2 {
        transform: rotateZ(60deg);
    }
    &.hour2 > span {
        transform: rotateZ(-60deg);
    }
    &.hour3 {
        transform: rotatez(90deg);
    }
    &.hour3 > span {
        transform: rotatez(-90deg);
    }
    &.hour4 {
        transform: rotatez(120deg);
    }
    &.hour4 > span {
        transform: rotatez(-120deg);
    }
    &.hour5 {
        transform: rotatez(150deg);
    }
    &.hour5 > span {
        transform: rotatez(-150deg);
    }
    &.hour6 {
        transform: rotatez(180deg);
    }
    &.hour6 > span {
        transform: rotatez(-180deg);
    }
    &.hour7 {
        transform: rotatez(210deg);
    }
    &.hour7 > span {
        transform: rotatez(-210deg);
    }
    &.hour8 {
        transform: rotatez(240deg);
    }
    &.hour8 > span {
        transform: rotatez(-240deg);
    }
    &.hour9 {
        transform: rotatez(270deg);
    }
    &.hour9 > span {
        transform: rotatez(-270deg);
    }
    &.hour10 {
        transform: rotatez(300deg);
    }
    &.hour10 > span {
        transform: rotatez(-300deg);
    }
    &.hour11 {
        transform: rotatez(330deg);
    }
    &.hour11 > span {
        transform: rotatez(-330deg);
}
`

const ClockCircle = styled.div`
vertical-align: middle;
width: ${props => props.size ? props.size: "150px" };
height: ${props => props.size ? props.size: "150px" };
border: ${props => props.border ? props.border: "2px solid" };
border-radius: 100%;
text-align: center;
font-size: 14px;
margin: auto;
margin-left: -10px;
background-color: ${props => props.bg ? props.bg: "transparent" };
&:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    content: "";
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background-color: ${props => props.handleColor ? props.handleColor: "#666666" };
}
`

const ClockHandle = styled.div`
position: absolute;
top: 15%;
left: 50%;
display: block;
width: 2px;
height: 35%;
margin-left: -1px;
border-radius: 5px;
transform-origin: bottom;
background-color: ${props => props.handleColor ? props.handleColor: "#666666" };

&.hour-handle{
    top: 30%;
    width: 4px;
    height: 20%;
    margin-left: -2px;
}
&.second-handle {
    width: 1px;
}
}

`

const Clock = ({time, color, border, bg, size, handleColor}) => {
    // eslint-disable-next-line no-unused-vars
    const [timeList, setTimeList] = useState([12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
    // eslint-disable-next-line no-unused-vars
    const [clockTansform, setClockTransform] = useState("scale(1)")
    const [hourRotate, setHourRotate] = useState("rotateZ(0deg)")
    const [minuteRotate, setMinuteRotate] = useState("rotateZ(0deg)")
    const [secondRotate, setSecondRotate] = useState("rotateZ(0deg)")

    const showTime = () => {
        let times;
        if (time) {
            times = time.split(":");
        } else {
            const now = new Date();
            times = [now.getHours(), now.getMinutes(), now.getSeconds()];
        }
        let hour = +times[0];
        hour = hour > 11 ? hour - 12 : hour;
        let minute = +times[1];
        let second = +times[2] || 0;
        let hourAngle = hour * 30 + minute * 6 / 360 * 30;
        let minuteAngle = minute * 6;
        let secondAngle = second * 6;
        setHourRotate(`rotateZ(${hourAngle}deg)`);
        setMinuteRotate(`rotateZ(${minuteAngle}deg)`);
        setSecondRotate(`rotateZ(${secondAngle}deg)`);
    }

    useEffect(() => {
        showTime()
        if (!time) {
            var _timer = setInterval(() => {
                showTime();
            }, 1000);
        }
        return () => {
            if (_timer) clearInterval(_timer);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ClockMain color={color}>
        <ClockCircle size={size} border={border} bg={bg}></ClockCircle>
        <ClockHandle handleColor={handleColor} className="hour-handle" style={{transform:hourRotate}}></ClockHandle>
        <ClockHandle handleColor={handleColor} className="minute-handle" style={{transform:minuteRotate}}></ClockHandle>
        <ClockHandle handleColor={handleColor} className="second-handle" style={{transform:secondRotate}}></ClockHandle>
        {timeList.map((h,index)=>{
            return(
                <HourNumber className={`hour${index}`} key={index}>
                    <span>
                        <i style={{transform:`${clockTansform}`}}>{`${h}`}</i>
                    </span>
                </HourNumber>
                    )
        })}
        </ClockMain>
    )
}

export default Clock
